import { LineChart, Brain, Code, ClipboardList } from 'lucide-react';
import { Service } from '@/types/service.types';

export const services: Service[] = [
	{
		id: 'strategy',
		title: 'Strategy & Roadmaps',
		description:
			"Transform your business vision into actionable technology plans. As your fractional vCIO, I'll help define clear goals, prioritize initiatives, and create roadmaps that align technology with your business growth.",
		icon: Brain,
		gradient: 'from-blue-500 to-indigo-500',
		image: '/images/services/strategy.png',
		features: [
			{
				name: 'Technology Assessment',
				description:
					'Get a comprehensive review of your current tech stack, processes, and opportunities for improvement.',
				capabilities: [
					'Current systems audit',
					'Process efficiency analysis',
					'Technology gap assessment',
					'Cost-benefit analysis',
				],
			},
			{
				name: 'Strategic Planning',
				description:
					'Develop clear, actionable technology roadmaps that support your business goals and growth plans.',
				capabilities: [
					'Technology roadmap development',
					'Initiative prioritization',
					'Resource planning',
					'Risk assessment',
				],
			},
			{
				name: 'vCIO Services',
				description:
					'Access enterprise-grade technology leadership on a flexible, fractional basis that fits your budget.',
				capabilities: [
					'Monthly strategy sessions',
					'Technology governance',
					'Vendor management',
					'Budget optimization',
				],
			},
		],
	},
	{
		id: 'automation',
		title: 'Internal Tools & Automation',
		description:
			'Streamline operations and reduce manual work with custom-built internal tools and intelligent automations. From Power Apps to workflow automation, I create solutions that make your business more efficient.',
		icon: Code,
		image: '/images/services/automation.png',
		features: [
			{
				name: 'Custom Power Apps',
				description:
					'Build tailored business applications that solve your specific operational challenges.',
				capabilities: [
					'Process-specific apps',
					'Microsoft 365 integration',
					'Mobile-friendly interfaces',
					'Role-based access control',
				],
			},
			{
				name: 'Workflow Automation',
				description:
					'Automate repetitive tasks and complex business processes with Power Automate and custom solutions.',
				capabilities: [
					'Process automation',
					'Cross-system integration',
					'Error handling and recovery',
					'Process monitoring and analytics',
				],
			},
			{
				name: 'Business Process Optimization',
				description:
					'Identify and implement improvements to your core business processes through technology.',
				capabilities: [
					'Process analysis and mapping',
					'Bottleneck identification',
					'Efficiency improvements',
					'Change management support',
				],
			},
		],
	},
	{
		id: 'analytics',
		title: 'Analytics & Dashboards',
		description:
			'Turn your business data into actionable insights with custom dashboards and reporting systems. Make smarter decisions with real-time visibility into your key metrics and performance indicators.',
		icon: LineChart,
		image: '/images/services/analytics.png',
		features: [
			{
				name: 'Custom Dashboards',
				description:
					'Create intuitive, real-time dashboards that give you visibility into your most important business metrics.',
				capabilities: [
					'KPI tracking and visualization',
					'Interactive data exploration',
					'Automated reporting',
					'Mobile-friendly views',
				],
			},
			{
				name: 'Data Integration',
				description:
					'Connect and consolidate data from multiple sources into a single source of truth for your business.',
				capabilities: [
					'Multi-source data integration',
					'Data cleaning and transformation',
					'Automated data pipelines',
					'Data quality monitoring',
				],
			},
			{
				name: 'Business Intelligence',
				description:
					'Transform raw data into actionable business insights that drive growth and optimization.',
				capabilities: [
					'Predictive analytics',
					'Trend analysis',
					'Performance benchmarking',
					'Custom reporting',
				],
			},
		],
	},
	{
		id: 'oversight',
		title: 'Project Oversight & Support',
		description:
			'Get expert guidance and hands-on support throughout your technology projects. From planning to implementation and beyond, I ensure your initiatives stay on track and deliver real business value.',
		icon: ClipboardList,
		image: '/images/services/oversight.png',
		features: [
			{
				name: 'Project Management',
				description:
					'Receive comprehensive project oversight that keeps your technology initiatives on time and on budget.',
				capabilities: [
					'Timeline and milestone tracking',
					'Resource coordination',
					'Risk management',
					'Stakeholder communication',
				],
			},
			{
				name: 'Technical Support',
				description:
					'Access reliable technical expertise and support for your business systems and tools.',
				capabilities: [
					'System maintenance',
					'Troubleshooting support',
					'User training',
					'Documentation and knowledge base',
				],
			},
			{
				name: 'Growth Partnership',
				description:
					'Build a long-term technology partnership that evolves with your business needs and goals.',
				capabilities: [
					'Regular strategy reviews',
					'Technology roadmap updates',
					'Continuous improvement',
					'Scalability planning',
				],
			},
		],
	},
];
